import { SideMenu } from 'src/app/models';

export const links: Record<string, SideMenu[]> = {
    colaborador: [
        {
            menu: 'Colaborador',
            id: 'colaborador',
            submenus: [
                {
                    id: 'dados basicos',
                    title: 'Dados básicos',
                    href: '/colaborador/dados-basicos',
                },
                {
                    id: 'enderecos',
                    title: 'Endereços',
                    href: '/colaborador/endereco',
                },
                {
                    id: 'dados bancarios',
                    title: 'Dados bancários',
                    href: '/colaborador/dados-bancarios',
                },
                {
                    id: 'formacao',
                    title: 'Formação',
                    href: '/colaborador/formacao',
                },
            ],
        },
        {
            menu: 'Funcional',
            id: 'funcional',
            warn: false,
            submenus: [
                {
                    id: 'vinculos',
                    title: 'Vínculos',
                    href: '/colaborador/funcional/vinculos',
                },
                {
                    id: 'ocorrencias',
                    title: 'Ocorrências',
                    href: '/colaborador/funcional/ocorrencias',
                },
                {
                    id: 'recibos',
                    title: 'Recibos',
                    href: '/colaborador/funcional/recibos',
                },
            ],
        },
        {
            menu: 'Org. e funcionamento',
            id: 'org-funcionamento',
            warn: false,
            submenus: [
                {
                    id: 'tarefas_atender',
                    menu: 'Tarefas',
                    warn: false,
                    title: 'Tarefas',
                    submenus: [
                        {
                            id: 'tarefas_atender',
                            title: 'Atender',

                            href: '/colaborador/org-funcionamento/tarefas/atender',
                        },
                    ],
                },
            ],
        },
        {
            menu: 'Requisições',
            id: 'requisicoes',
            warn: false,
            submenus: [
                {
                    id: 'atendimento_pendente_usuario',
                    title: 'Atender',
                    href: '/colaborador/requisicoes/atender',
                },
                {
                    id: 'cadastrar',
                    title: 'Cadastrar',
                    href: '/colaborador/requisicoes/cadastrar',
                },
                {
                    id: 'consultar',
                    title: 'Consultar',
                    href: '/colaborador/requisicoes/consultar',
                },
            ],
        },
    ],

    publico: [
        {
            menu: 'Conhecimento',
            id: 'conhecimento',
            submenus: [
                {
                    id: 'conhecimento-publicacoes',
                    title: 'Publicações',
                    href: '/publico/conhecimento/publicacoes/consultar',
                },
            ],
        },
    ],

    administrador: [
        {
            menu: 'Projetos',
            id: 'projetos',
            submenus: [
                {
                    href: '/administrador/projetos/consultar',
                    title: 'Consultar',
                    id: 'projetos-consultar',
                },
                {
                    href: '/administrador/projetos/prestacao-contas',
                    title: 'Prestação de contas',
                    id: 'prestacao-contas',
                },
            ],
        },
        {
            menu: 'Colaboradores',
            id: 'colaboradores',
            submenus: [
                {
                    menu: 'Consultar',
                    id: 'colaboradores-consultar',
                    submenus: [
                        {
                            href: '/administrador/colaboradores/consultar',
                            title: 'Colaborador',
                            id: 'colaboradores-consultar',
                        },
                        {
                            href: '/administrador/colaboradores/consultar-ferias',
                            title: 'Férias',
                            id: 'colaboradores-consultar-ferias',
                        },
                        {
                            href: '/administrador/colaboradores/consultar-periodos-aquisitivos',
                            title: 'Períodos aquisitivos',
                            id: 'colaboradores-consultar-periodos-aquisitivos',
                        },
                    ],
                },
                {
                    href: '/administrador/colaboradores/encargos',
                    title: 'Encargos',
                    id: 'colaboradores-encargos',
                },
                {
                    href: '/administrador/folha-pagamento/consultar',
                    title: 'Folha de Pagamento',
                    id: 'colaboradores-consultar-folha',
                },
                {
                    href: '/administrador/colaboradores/passivo-trabalhista/consultar',
                    title: 'Passivo Trabalhista',
                    id: 'colaboradores-passivo-trabalhista',
                },
            ],
        },
        {
            menu: 'Conhecimento',
            id: 'conhecimento',
            submenus: [
                {
                    href: '/administrador/conhecimento/dominios',
                    title: 'Domínios de gestão',
                    id: 'dominios-gestao',
                },
                {
                    href: '/administrador/conhecimento/papeis-trabalho',
                    title: 'Papéis de trabalho',
                    id: 'papeis-trabalho',
                },
                {
                    href: '/administrador/conhecimento/conceitos/consultar',
                    title: 'Conceitos',
                    id: 'conceitos',
                },
            ],
        },
        {
            menu: 'Documentos',
            id: 'documentos',
            submenus: [
                {
                    href: '/administrador/documentos/consultar',
                    title: 'Consultar',
                    id: 'documentos-consultar',
                },
            ],
        },
        {
            menu: 'Financeiro',
            id: 'financeiro',
            submenus: [
                {
                    href: '/administrador/financeiro/contas/consultar',
                    title: 'Contas',
                    id: 'financeiro-contas',
                },
                {
                    href: '/administrador/financeiro/movimentacoes/consultar',
                    title: 'Movimentações',
                    id: 'financeiro-movimentacoes',
                },
                {
                    href: '/administrador/financeiro/conciliacao',
                    title: 'Conciliação',
                    id: 'financeiro-conciliacao',
                },
            ],
        },
        {
            menu: 'Infraestrutura',
            id: 'infraestrutura',
            warn: false,
            submenus: [
                {
                    menu: 'Agendamentos',
                    warn: false,
                    id: 'infraestrutura-agendamentos',
                    submenus: [
                        {
                            href: '/administrador/infraestrutura/agendamentos/consultar',
                            title: 'Consultar',
                            id: 'agendamentos-consultar',
                        },
                        {
                            href: '/administrador/infraestrutura/agendamentos/processar',
                            title: 'Processar',
                            id: 'agendamentos-processar',
                        },
                    ],
                },
                {
                    href: '/administrador/infraestrutura/bens/',
                    title: 'Bens',
                    id: 'bens',
                },
                {
                    href: '/administrador/infraestrutura/espacos-fisicos/',
                    title: 'Espaços físicos',
                    id: 'espacos-fisicos',
                },
                {
                    href: '/administrador/infraestrutura/necessidades',
                    title: 'Necessidades',
                    id: 'necessidades',
                },
            ],
        },
        {
            menu: 'Org. e funcionamento',
            id: 'organizacao',
            warn: false,
            submenus: [
                {
                    id: 'organizacao-tarefas-processar',
                    menu: 'Tarefas',
                    title: 'Tarefas',
                    submenus: [
                        {
                            id: 'organizacao-tarefas-cadastrar',
                            title: 'Cadastrar',
                            href: '/administrador/org-funcionamento/tarefas/cadastrar',
                        },
                        {
                            id: 'organizacao-tarefas-consultar',
                            title: 'Consultar',
                            href: '/administrador/org-funcionamento/tarefas/consultar',
                        },
                        {
                            id: 'organizacao-tarefas-processar',
                            title: 'Processar',
                            href: '/administrador/org-funcionamento/tarefas/processar',
                        },
                        {
                            id: 'organizacao-tarefas-painel',
                            title: 'Painel de tarefas',
                            href: '/administrador/org-funcionamento/tarefas/painel',
                        },
                    ],
                },
            ],
        },
        {
            menu: 'Requisições',
            id: 'requisicoes',
            warn: false,
            submenus: [
                {
                    href: '/administrador/requisicoes/cadastrar',
                    title: 'Cadastrar',
                    id: 'requisicoes-cadastrar',
                },
                {
                    href: '/administrador/requisicoes/consultar',
                    title: 'Consultar',
                    id: 'requisicoes-consultar',
                },
                {
                    href: '/administrador/requisicoes/pendentes',
                    title: 'Pendentes',
                    id: 'requisicoes-pendentes',
                },
                {
                    href: '/administrador/requisicoes/processar',
                    title: 'Processar',
                    id: 'requisicoes-processar',
                },
            ],
        },
        {
            menu: 'Suprimentos',
            id: 'suprimentos',
            warn: false,
            submenus: [
                {
                    href: '/administrador/suprimentos/fornecedores/',
                    title: 'Fornecedores',
                    id: 'suprimentos-fornecedores-consultar',
                },
                {
                    menu: 'Notas fiscais',
                    id: 'suprimentos-notas-fiscais',
                    warn: false,
                    submenus: [
                        {
                            href: '/administrador/suprimentos/notas-fiscais/cadastrar-avulsa',
                            title: 'Cadastrar',
                            id: 'suprimentos-notas-fiscais-cadastrar-avulsa',
                        },
                        {
                            href: '/administrador/suprimentos/notas-fiscais/consultar',
                            title: 'Consultar',
                            id: 'suprimentos-notas-fiscais-consultar',
                        },
                        {
                            href: '/administrador/suprimentos/notas-fiscais',
                            title: 'Processar',
                            query: { processar: true },
                            id: 'suprimentos-notas-fiscais-processar',
                        },
                    ],
                },
                {
                    menu: 'Ordens',
                    id: 'suprimentos-ordens',
                    warn: false,
                    submenus: [
                        {
                            href: '/administrador/suprimentos/ordens/consultar',
                            title: 'Consultar',
                            id: 'suprimentos-ordens-consultar',
                        },
                        {
                            href: '/administrador/suprimentos/ordens',
                            title: 'Processar',
                            query: { processar: true },
                            id: 'suprimentos-ordens-processar',
                        },
                    ],
                },

                {
                    href: '/administrador/suprimentos/produtos/',
                    title: 'Produtos',
                    id: 'suprimentos-produtos-consultar',
                },
            ],
        },
    ],

    coordenador: [
        {
            menu: 'Projeto',
            title: 'Projeto',
            id: 'projeto',
            submenus: [
                {
                    href: '/coordenador/projeto/dados',
                    title: 'Dados',
                    id: 'projeto-dados',
                },
                {
                    href: '/coordenador/projeto/graficos',
                    title: 'Gráficos',
                    id: 'projeto-graficos',
                },
                {
                    href: '/coordenador/projeto/prestacao-contas/listar',
                    title: 'Prestação de contas',
                    id: 'prestacao-contas',
                },
            ],
        },
        {
            menu: 'Colaboradores',
            id: 'colaboradores',
            submenus: [
                {
                    href: '/coordenador/colaboradores/consultar',
                    title: 'Consultar',
                    id: 'colaboradores-consultar',
                },
                {
                    href: '/coordenador/colaboradores/encargos',
                    title: 'Encargos',
                    id: 'colaboradores-encargos',
                },
                {
                    href: '/coordenador/colaboradores/equipe-projeto',
                    title: 'Equipe',
                    id: 'colaboradores-dados',
                },
                {
                    href: '/coordenador/colaboradores/folha-pagamento/consultar',
                    title: 'Folha de Pagamento',
                    id: 'colaboradores-consultar-folha',
                },
                {
                    href: '/coordenador/colaboradores/passivo-trabalhista',
                    title: 'Passivo Trabalhista',
                    id: 'colaboradores-passivo-trabalhista',
                },
            ],
        },
        {
            menu: 'Conhecimento',
            id: 'conhecimento',
            submenus: [
                {
                    href: '/coordenador/conhecimento/dominios',
                    title: 'Domínios de gestão',
                    id: 'dominios-gestao',
                },
                {
                    href: '/coordenador/conhecimento/papeis-trabalho',
                    title: 'Papéis de trabalho',
                    id: 'papeis-trabalho',
                },
                {
                    href: '/coordenador/conhecimento/conceitos/consultar',
                    title: 'Conceitos',
                    id: 'conceitos',
                },
            ],
        },
        {
            menu: 'Financeiro',
            id: 'financeiro',
            submenus: [
                {
                    href: '/coordenador/financeiro/contas/consultar',
                    title: 'Contas',
                    id: 'financeiro-contas',
                },
                {
                    href: '/coordenador/financeiro/movimentacoes/consultar',
                    title: 'Movimentações',
                    id: 'financeiro-movimentacoes',
                },
            ],
        },
        {
            menu: 'Infraestrutura',
            id: 'infraestrutura',
            warn: false,
            submenus: [
                {
                    href: '/coordenador/infraestrutura/necessidades',
                    title: 'Necessidades',
                    id: 'necessidades',
                },
            ],
        },
        {
            menu: 'Requisições',
            id: 'requisicoes',
            warn: false,
            submenus: [
                {
                    href: '/coordenador/requisicoes/autorizar',
                    title: 'Autorizar',
                    id: 'requisicoes-autorizar',
                },
                {
                    href: '/coordenador/requisicoes/consultar',
                    title: 'Consultar',
                    id: 'requisicoes-consultar',
                },
            ],
        },
        {
            menu: 'Suprimentos',
            id: 'suprimentos',
            warn: false,
            submenus: [
                {
                    href: '/coordenador/suprimentos/notas-fiscais',
                    title: 'Notas fiscais',
                    id: 'suprimentos-notas-fiscais',
                },
                {
                    href: '/coordenador/suprimentos/faturas',
                    title: 'Faturas',
                    id: 'suprimentos-faturas',
                },
            ],
        },
        {
            menu: 'Viagens',
            id: 'viagens',
            submenus: [
                {
                    href: '/coordenador/viagens/dados',
                    title: 'Dados',
                    id: 'viagens-dados',
                },
                {
                    href: '/coordenador/viagens/graficos',
                    title: 'Gráficos',
                    id: 'viagens-graficos',
                },
            ],
        },
    ],

    gestor: [
        {
            menu: 'Colaboradores',
            id: 'colaboradores',
            submenus: [
                {
                    href: '/gestor/colaboradores/consultar',
                    title: 'Consultar',
                    id: 'colaboradores-consultar',
                },
                {
                    href: '/gestor/colaboradores/encargos',
                    title: 'Encargos',
                    id: 'colaboradores-encargos',
                },
                {
                    href: '/gestor/folha-pagamento/consultar',
                    title: 'Folha de Pagamento',
                    id: 'consultar-folha',
                },
                {
                    href: '/gestor/colaboradores/passivo-trabalhista/consultar',
                    title: 'Passivo Trabalhista',
                    id: 'colaboradores-passivo-trabalhista',
                },
            ],
        },
        {
            menu: 'Orçamento',
            id: 'orcamento',
            submenus: [
                {
                    href: '/gestor/orcamento/consulta-analitica',
                    title: 'Analítico',
                    id: 'orcamento-consulta-analitica',
                },
                {
                    href: '/gestor/orcamento/consulta-sintetica',
                    title: 'Sintético',
                    id: 'orcamento-consulta-sintetica',
                },
            ],
        },
    ],
};
